import isPropValid from '@emotion/is-prop-valid';

const shouldForwardProp =
  (...custom: string[]) =>
  (prop: string) =>
    isPropValid(prop) && custom.indexOf(prop) === -1;

export default shouldForwardProp;
